import React, { useEffect } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

export const CancelEnvelopeFolderErrorDialog = (props) => {

    const {cancelEnvelopeFolderError, setCancelEnvelopeFolderError} = props

    useEffect(() => {
        let timeoutId;
        if (cancelEnvelopeFolderError) {
            timeoutId = setTimeout(() => {
                setCancelEnvelopeFolderError(false)
            }, 2000);
        }
        return () => {
            clearTimeout(timeoutId)

        };
    }, [cancelEnvelopeFolderError,setCancelEnvelopeFolderError]);

    return (
        <dialog
            className="dialog--temporary"
            open={cancelEnvelopeFolderError}
            onClose={()=>setCancelEnvelopeFolderError(false)}
        >
            <div className="dialog__row-container">
                <header>
                    <h2>
                    Erro ao cancelar a pasta
                    </h2>
                </header>
                <IconButton 
                    onClick={()=>setCancelEnvelopeFolderError(false)}
                >
                    <CloseIcon />
                </IconButton>
            </div>
        </dialog>
    );
}